import React from 'react';
import { Icon } from '@ontruck/orc';

const TopLoad = ({ cellData }) => {
  return cellData ? <Icon size="4rem" glyph="extras-retractableroof" color="grey500" /> : null;
};

export default TopLoad;
